import styled from "styled-components";
import { theme } from "../../../../../../constants/StyledComponents";

export const StyledNoteComponent = styled.div`
  padding: 20px;
  border-radius: 12px;
  background-color: ${theme.colors.purple_5};
  display: flex;
  flex-direction: row;
  position: relative;
  overflow-wrap: anywhere;
  gap: 20px;
`;

export const StyledNoteBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 35px;
  gap: 15px;
`;

export const StyledDataWritingNote = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledDeleteNote = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  position: absolute;
  bottom: 20px;
  right: 20px;
  background-color: ${theme.colors.trasparent};
  border: none;
  cursor: pointer;
`;
